import request from "../../utils/request-axios";
import api from "../../utils/api";

//说明文档列表
export function getDocumentDescriptionPage(params) {
  return request(`${api.getDocumentDescriptionPage}`, {
    loading: true,
    method: 'get',
    data: params,
  })
}

//新增标题
export function addDocument(params) {
  return request(`${api.addDocument}`, {
    loading: true,
    method: 'post',
    data: params,
  })
}

//预览文档
export function previewDocument(params) {
  return request(`${api.previewDocument}`, {
    loading: true,
    method: 'get',
    data: params,
  })
}

//编辑说明文档
export function editDocumentDescription(params) {
  return request(`${api.editDocumentDescription}`, {
    loading: true,
    method: 'put',
    data: params,
  })
}

//删除标题
export function deleteDocument(params) {
  return request(`${api.deleteDocument}${params}`, {
    loading: true,
    method: 'delete',
  })
}

//根据ID查询
export function getDocumentId(params) {
  return request(`${api.getDocumentId}${params}`, {
    loading: true,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/services/file/explainFile.js